module.exports = __webpack_public_path__ + "media/icon/icon-bear-gray-f45c6b74.svg";